import { User } from "../../../model";
import { apiService } from "../../ApiService";

export type UpdateMSISDNFormData = {
  msisdn: string;
  otp: string;
};

export const updateMsisdn = (data: UpdateMSISDNFormData) => {
  return apiService.put<{ user: User }>({
    path: `v1/me/msisdn`,
    body: data,
    requiresAuthPolicy: "user",
  });
};
